import React from 'react'
import './Enables.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useIndustrySection } from '../../../../context/IndustryPageContext'
import { getListItemsFromSection } from '../../../../services/contentApi'

const Enables = () => {
  const { section, loading } = useIndustrySection('enables')

  if (loading || !section?.fields) return null

  const fields = section.fields
  const items = getListItemsFromSection(section)

  return (
    <section className="enables">
      <div className="enables-container">
        <CmsText
          content={fields.subtitle}
          as="p"
          className="enables-subtitle"
        />
        <CmsText content={fields.title} as="h2" className="enables-title" />
        <RichTextContent
          content={fields.description}
          className="enables-description"
        />

        <div className="enables-pills">
          {items.map((item, index) => (
            <div key={index} className="enables-pill">
              <CmsText content={item} as="span" />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Enables
